import { DateTime, Settings } from 'luxon';

// Converts a JS Date (browser's timezone) to a Luxon DateTime (org's timezone due to Settings.defaultZone, with same time value)
export function BrowserJSDateToOrgLuxonDateTime(date: Date) {
  return DateTime.fromJSDate(date, { zone: 'local' }).setZone(
    Settings.defaultZone,
    { keepLocalTime: true }
  );
}
